var React = require('react');

function FooterWave (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"wave-bottom"),React.createElement("g",{"key":1},React.createElement("path",{"d":"M1920,157.624l0,82.231l-1920,0l0,-106.045c54.693,-9.327 89,45.297 242,56.045c153,10.748 265.5,-30.5 411,-30.5c145.5,0 603,131.5 1267,-1.731Z"}))]);
}

FooterWave.defaultProps = {"fillRule":"evenodd","clipRule":"evenodd","viewBox":"0 0 1920 240"};

module.exports = FooterWave;

FooterWave.default = FooterWave;
